export default {
  CREATE_BUCKET_INVESTOR_GOAL_V2_COMMAND: Symbol.for('CREATE_BUCKET_INVESTOR_GOAL_V2_COMMAND'),
  BUCKET_INVESTOR_GOAL_REPOSITORY: Symbol.for('BUCKET_INVESTOR_GOAL_REPOSITORY'),
};
